import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { hasMinRole } from '@/utils/roles';
import { Role } from '@avgrp/shared';
import type { ReactNode } from 'react';

interface RoleGuardProps {
  minRole: Role;
  children: ReactNode;
}

/**
 * Route-level guard that redirects to dashboard if the user's role is insufficient.
 */
export function RoleGuard({ minRole, children }: RoleGuardProps) {
  const { user } = useAuth();

  if (!hasMinRole(user?.role, minRole)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
